import { HeaderWrapper } from '@/components/Header/HeaderWrapper';
import { HeaderLogo } from '@/components/Header/HeaderLogo';

const PartnerhubSimpleHeader = ({ lang = 'en' }: { lang?: string }) => {
    return (
        <HeaderWrapper isShowShadow>
            <div className="tw-flex tw-flex-row tw-items-center tw-justify-center">
                <div className="tw-flex tw-flex-row tw-items-center">
                    <HeaderLogo
                        className="tw-cursor-pointer tw-mr-[20px]"
                        link={`/${lang}/clienthub`}
                        forcePageRefresh
                    />
                </div>
            </div>
        </HeaderWrapper>
    );
};

export default PartnerhubSimpleHeader;
